import React, { FC, Suspense } from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';

import { hasLiveSession } from './lib/auth/session-token';
import FallbackComponent from './components/fallback.comp';

import HomePage from './app/pages/HomePage/home.page';

const isAllowed = () => hasLiveSession();

const PrivateRoute: FC<{ element: any }> = ({ element: Element }) => {
  return isAllowed() ? (
    <Suspense fallback={<FallbackComponent />}>
      <Element />
    </Suspense>
  ) : (
    <Navigate to={'/signIn'} />
  );
};

const PublicRoute: FC<{ element: any }> = ({ element: Element }) => (
  <Suspense fallback={<FallbackComponent />}>
    <Element />
  </Suspense>
);

const LoginPage = React.lazy(() => import('./app/store/login/index'));
const SignUpPage = React.lazy(() => import('./app/pages/SignUpPage/signUp.page'));
const MainPage = React.lazy(() => import('./app/index'));

const AppRoutes = () => {
  return (
    <Routes>
      <Route path={'/signUp'} element={<PublicRoute element={SignUpPage} />} />
      <Route path={'/signIn'} element={<PublicRoute element={LoginPage} />} />

      <Route path={'/'} element={<PublicRoute element={HomePage} />} />

      <Route path={'main/*'} element={<PrivateRoute element={MainPage} />} />

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default AppRoutes;
